let globalLogout = null;

export function registerGlobalLogout(logout) {
  globalLogout = typeof logout === 'function' ? logout : null;
}

export function callGlobalLogout() {
  if (typeof globalLogout === 'function') {
    globalLogout();
  }
}
